"use client";

import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Card } from "@/components/ui/card";
gsap.registerPlugin(useGSAP, ScrollTrigger);
export default function Technical() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".tf-header", {
        y: 20
      });
      gsap.to(".tf-header", {
        opacity: 1,
        y: 0,
        duration: 0.64,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          once: true
        }
      });
      gsap.set(".tf-card", {
        y: 24
      });
      gsap.to(".tf-card", {
        opacity: 1,
        y: 0,
        duration: 0.64,
        ease: "power3.out",
        stagger: 0.1,
        scrollTrigger: {
          trigger: ".tf-grid",
          start: "top 85%",
          once: true
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".tf-header", ".tf-card"], {
        opacity: 1,
        y: 0
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="31372" id="agriculturalcontentshowcase" data-nav="dark" className="bg-background text-foreground py-24 md:py-44 px-6">
      <div ref={container} className="mx-auto w-full max-w-[1360px]">
        {}
        <div className="tf-header mx-auto max-w-[720px] text-center" style={{
        opacity: 0
      }}>
          <p className="text-xs font-medium uppercase tracking-[0.22em] text-muted-foreground">Melhore a qualidade do produto e reduza o desperdício. Os processadores de alimentos para animais de estimação dependem da aplicação precisa nas suas operações de pulverização, mantendo simultaneamente a eficiência operacional através da automatização. A otimização do desempenho nos processos de produção melhora os resultados financeiros da sua empresa e permite obter produtos finais de elevada qualidade.</p>
          <h2 className="mt-6 font-default text-4xl md:text-5xl lg:text-6xl font-medium leading-[1.06] tracking-tight text-foreground">Tecnologia de Pulverização para Racções Animais</h2>
        </div>

        {}
        <div className="tf-grid mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {}
          <Card data-index={0} className="tf-card border border-border bg-card rounded-3xl p-8 flex flex-col justify-between transition-all duration-300 hover:-translate-y-1 hover:border-primary shadow-md overflow-hidden" style={{
          opacity: 0
        }}>
            <div>
              <h3 className="font-default text-2xl font-medium tracking-tight text-foreground">Obter Resultados com o Controlo Preciso de Pulverização AutoJet®</h3>
              <p className="mt-4 text-base leading-relaxed text-muted-foreground">Os sistemas de pulverização AutoJet são especificamente concebidos para controlar a aplicação de produtos durante o processamento, minimizando o desperdício nestas aplicações: Agentes de desmoldagem, Unidades de rendering, Processamento de alimentos secos, Aplicação uniforme de aromatizantes, palatantes, vitaminas e muito mais</p>
            </div>
            <div className="mt-8 overflow-hidden rounded-2xl border border-border/60 bg-muted/30">
              <img alt="Aplicação de Líquidos em Pellets Eurocontrol" className="w-full h-56 object-cover transition-transform duration-500 hover:scale-105" loading="lazy" src="https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-06-as-15.54.45.png" />
            </div>
          </Card>

          {}
          <Card data-index={1} className="tf-card border border-border bg-card rounded-3xl p-8 flex flex-col justify-between transition-all duration-300 hover:-translate-y-1 hover:border-primary shadow-md overflow-hidden" style={{
          opacity: 0
        }}>
            <div>
              <h3 className="font-default text-2xl font-medium tracking-tight text-foreground">Pistolas e Bicos de Limpeza de Transportadores e Equipamentos</h3>
              <p className="mt-4 text-base leading-relaxed text-muted-foreground">Manter a sua instalação limpa tem de ser eficiente, sem comprometer a qualidade. A nossa vasta gama de soluções ajuda a reduzir o tempo de limpeza, desinfetar zonas de difícil acesso, diminuir a utilização de produtos químicos dispendiosos e muito mais.
Saiba mais sobre as nossas pistolas de pulverização manuais.</p>
            </div>
            <div className="mt-8 overflow-hidden rounded-2xl border border-border/60 bg-muted/30">
              <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/vapor_conditioning.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/vapor_conditioning.png-wvc-sizes" alt="Sistema de Condicionamento a Vapor para Pellets" className="w-full h-56 object-cover transition-transform duration-500 hover:scale-105" loading="lazy" src="https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-06-as-15.57.05.png" />
            </div>
          </Card>

          {}
          <Card data-index={2} className="tf-card border border-border bg-card rounded-3xl p-8 flex flex-col justify-between transition-all duration-300 hover:-translate-y-1 hover:border-primary shadow-md overflow-hidden" style={{
          opacity: 0
        }}>
            <div>
              <h3 className="font-default text-2xl font-medium tracking-tight text-foreground">Manifolds e Bicos Lightning Lock®</h3>
              <p className="mt-4 text-base leading-relaxed text-muted-foreground">Com os produtos Lightning Lock, pode reduzir o tempo de manutenção e poupar água, substituindo facilmente os bicos com tempo de paragem mínimo, para manter o máximo poder de limpeza.</p>
            </div>
            <div className="mt-8 overflow-hidden rounded-2xl border border-border/60 bg-muted/30">
              <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/additives_enzymes.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/additives_enzymes.png-wvc-sizes" alt="Sistemas de Doseamento de Aditivos e Enzimas Pós-Peletização" className="w-full h-56 object-cover transition-transform duration-500 hover:scale-105" loading="lazy" src="https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-06-as-15.54.55.png" />
            </div>
          </Card>
        </div>
      </div>
    </section>;
}